export const DEAL_COMMISSIONS_ERROR =
  'We could not correctly process this deal. Please check all commissions in the Commission Tracker and try again.';
